export default "__VITE_ASSET__3fwCp0R8__"